import { render, staticRenderFns } from "./PrintDesigner.vue?vue&type=template&id=b1a36620&scoped=true"
import script from "./PrintDesigner.vue?vue&type=script&lang=js"
export * from "./PrintDesigner.vue?vue&type=script&lang=js"
import style0 from "./PrintDesigner.vue?vue&type=style&index=0&id=b1a36620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a36620",
  null
  
)

export default component.exports